import React, { useEffect } from "react";
import { Outlet, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import * as _ from "lodash";
import "./index.scss";
import Tabs from "../../../components/core/tab";
import { useTranslation } from "react-i18next";
import { readProfileFormByProfileId } from "../../../store/profile-form/thunkAction";

const ProfileForm = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const params = useParams();
  const profileId = _.get(params, "id");

  useEffect(() => {
    dispatch(readProfileFormByProfileId(profileId));
  }, [profileId, dispatch]);

  const configTabs = {
    isPath: true,
    tabs: [
      { label: t("settings.profile.configurations"), path: `/profile/${profileId}/form/config` },
      {
        label: t("settings.profile.fields"),
        path: `/profile/${profileId}/form/field`,
      },
    ],
  };

  return (
    <div className="container">
      <div>
        <div className="row header-title mb-4">
          <div className="col-lg-6">
            <h3 className="color-pri">{t("settings.profile.profile_form.title")}</h3>
          </div>
          <div className="col-lg-6 text-start text-lg-end align-self-center">
            <a className="default-link" href={`#/profile/${profileId}/detail`}>
              <i className="fa fa-arrow-left"></i> {t("settings.profile.profile_detail")}
            </a>
          </div>
        </div>
        <Tabs config={configTabs} />
        <br />
        <div>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default ProfileForm;
